import React, { Component } from 'react'
import NetworkDetector from "../HigherOrderComponents/NetworkDetector";
import Subadminsidebar from "../SubAdminSideBar"
import queryString from "query-string";
import SubAdminUserRequest from '../SubAdminUserRequest';

const SubAdminUserRequestPage = (props) => {
  if (props.location.search) {
    let values = queryString.parse(props.location.search);
    sessionStorage.setItem("token", values.token);
  }
    return (
      <Subadminsidebar>
        <SubAdminUserRequest />
      </Subadminsidebar>
    );
  };
  export default NetworkDetector(SubAdminUserRequestPage);
